import ilSignupIntegration, {
  initializeIlSignupIntegration,
  isIlSignupIntegrationActive,
  unregisterIlSignupIntegration,
} from './story-lib-il-signup-integration';

import ilConnectIntegration, {
  initializeIlConnectIntegration,
  isIlConnectIntegrationActive,
  unregisterIlConnectIntegration,
} from './story-lib-il-connect-integration';

import './story-lib-il-refinance-integration';
import './story-lib-il-refinance-resend-integration';

export function initializeAllStoryLibIntegrations() {
  const results = {
    ilSignup: initializeIlSignupIntegration(),
    ilConnect: initializeIlConnectIntegration(),
  };

  return results;
}

export function getIntegrationStatus() {
  return {
    ilSignup: isIlSignupIntegrationActive(),
    ilConnect: isIlConnectIntegrationActive(),
  };
}

export {
  ilSignupIntegration,
  initializeIlSignupIntegration,
  isIlSignupIntegrationActive,
  unregisterIlSignupIntegration,
  ilConnectIntegration,
  initializeIlConnectIntegration,
  isIlConnectIntegrationActive,
  unregisterIlConnectIntegration,
};

export default {
  initializeAll: initializeAllStoryLibIntegrations,
  getStatus: getIntegrationStatus,
  ilSignup: ilSignupIntegration,
  ilConnect: ilConnectIntegration,
};
